<template>
  <div class="card p-6 m-6">
    <p class="card-title">Daily Report</p>
    <div class="card-content">
      <div v-if="today_recruiter_vetting_count != undefined" class="is-uppercase">
        <p>Today's vetting: {{ today_recruiter_vetting_count }}</p>
      </div>
      <div v-if="today_offers_sent_count != undefined" class="is-uppercase">
        <p>offers sent: {{ today_offers_sent_count }}</p>
      </div>
      <div v-if="today_answer_count != undefined" class="is-uppercase">
        <p>Today's answers: {{ today_answer_count }}</p>
      </div>
      <div v-if="today_followup_count != undefined" class="is-uppercase">
        <p>Today's follow ups: {{ today_followup_count }}</p>
      </div>
      <div v-if="today_employer_calls_count != undefined" class="is-uppercase">
        <p>שיחות למעסיקים: {{ today_employer_calls_count }}</p>
      </div>
      <div v-if="today_admin_calls_count != undefined" class="is-uppercase">
        <p>שיחות אדמין לחברות: {{ today_admin_calls_count }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import TimeHelper from '@/custom/classes/time_helper.js'

export default {
  name: 'DailyReport',
  data () {
    return {
      time_helper: new TimeHelper(),
      today_recruiter_vetting_count: undefined,
      today_offers_sent_count: undefined,
      today_answer_count: undefined,
      today_followup_count: undefined,
      today_employer_calls_count: undefined,
      today_admin_calls_count: undefined
    }
  },
  created () {
    this.getTodayOffersSentCount()
    this.getRecruiterOffersSend()
    this.getTodayAnswerCount()
    this.getTodayFollowUpsCount()
    this.getTodayEmployerCallsCount()
    this.getTodayAdminCallsCount()
  },
  methods: {
    getTodayOffersSentCount () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'applicant_vetted,applicant_owner_changed', count_only: true, date_from, date_to }).then(response => {
        this.today_recruiter_vetting_count = response
      })
    },
    getRecruiterOffersSend () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'offer_to_awaiting_company_sent', count_only: true, date_from, date_to }).then(response => {
        this.today_offers_sent_count = response
      })
    },
    getTodayAnswerCount () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'applicant_answered_phone', count_only: true, date_from, date_to }).then(response => {
        this.today_answer_count = response
      })
    },
    getTodayFollowUpsCount () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'follow_up', count_only: true, date_from, date_to }).then(response => {
        this.today_followup_count = response
      })
    },
    getTodayEmployerCallsCount () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'employer_phone_call', count_only: true, date_from, date_to }).then(response => {
        this.today_employer_calls_count = response
      })
    },
    getTodayAdminCallsCount () {
      let date_from = this.time_helper.getToday().atMidnight().toUTCString()
      let date_to = this.time_helper.getTomorrow().atMidnight().toUTCString()
      this.$network_utils.getStats({ owner: this.$utils.getOwner().name, designator: 'admin_called_company', count_only: true, date_from, date_to }).then(response => {
        this.today_admin_calls_count = response
      })
    }
  }
}
</script>
